module.exports = __webpack_public_path__ + "static/media/cof_active.062b473a.png";